
import {
  categoryUrl,
  chargersUrl,
  teamsUrl,
  userTypeUrl,
  userUrl,
  transactionsUrl,
  getTeamUrl,
  transactionIdUrl,
  meterValueUrl,
  tagsUrl,
  tagsForRemoteOpUrl,
  availableTagsUrl,
  tagIdUrl,
  chargerIdUrl,
  priceGroupsUrl,
  priceGroupIdUrl,
  teamUrlId,
  teamUsersUrl,
  teamChargersWithoutLicenseUrl,
  teamAllowedChargerCountUrl,
  chargerLicenseUrl,
  getUserDetailUrl,
  usersUrl,
  getUserProfile,
  rolesUrl,
  chargerTransactions,
  tagTransactions,
  companyUrl,
  getRoleUrlId,
  featureUrl,
  getCompanyUrlId,
  viewLogsUrl,
  getConnectorsUrl,
  getTagsByChargerIdUrl,
  getCustomerById,
  customerTagsById,
  tagChargerUrl,
  chargerActiveTransactions,
  tagUserUrl,
  serviceRequestUrl,
  serviceRequestForParentUrl,
  getServiceRequestDetailsUrl,
  refundUrl,
  getSettlementPercentageUrl,
  getPaymentDetailsForPriceGroupUrl,
  getPaymentDetailsOfCompany,
  cmCustomerUrl,
  newGetTeamUrl,
  bulkCalPayoutsUrl,
  getTransactionUrl,
  getCurrenciesUrl,
  getSmsGatewayUrl,
  getTeamV3Url,
  cmsUsersUrl,
  resetPasswordByAdminUrl,
  cmUserWalletHistoryUrl,
  cmUserTransactionHistoryUrl,
  customerListByTeamIdUrl,
  getChargerInstructionBoardUrl,
  teamPayoutInvoices,
  getPayoutInvoicesPdfUrl,
  getDropDownValues,
  reportGst,
  productCatalogUrl,
  getProductCatalogUrlId,
  companyProductCatalogUrl,
  getCompanyProductCatalogUrlId,
  getCompanyProductCatalogUrl,
  getProductCategoryUrlId,
  productCategoryUrl,
  getERPDropDownValues,
  availablePaymentGatewayListByCompanyUrl,
  thirdPartySmsConfig,
  smsTemplatesUrl,
  getChargerListUrl,
  partnersUrl,
  onboardUrl,
  handshake,
  handshakeAsyncUrl,
  handshakeRetryUrl,
  handshakeCancelUrl,
  handshakeStatusAsyncUrl,
  ocpiTokensUrl,
  ocpiTokenUrl,
  partnerUrl,
  partnerByPartyIdUrl,
  partnerCommandsUrl,
  partnerSendCommandUrl,
  partnerCommandStatusUrl,
  partnerGetAllTokensUrl,
  commandBuilderDataUrl,
  commandsHistoryUrl,
  activeCommandsUrl,
  ongoingSessionsUrl,
  completedSessionsUrl,
  partnerGetAllTariffsUrl,
  emspMarkupUpsertUrl,
  getPayoutScheduleUrl,
  getEffectivePayoutScheduleUrl,
  getPayoutRunHistoryUrl,
  getPayoutRunSummaryUrl,
  getPayoutRunDetailUrl,
  analyticsUrl,
  analyticsTypesUrl,
  analyticsMetadataUrl,
  analyticsMetricsUrl,
  analyticsReportUrl,
  getAllLocationsUrl,
  dashboardDataUrl,
  promoCodesUrl,
  promoCodeByIdUrl,
  checkPromoCodeUrl,
  updatePromoCodeStatusUrl,
  mobileCustomersListByTeamIdUrl,
  sendPromoCodeMobileCustomerUrl,
  cmUserDetailsUrl,
  getPromoCodesUrl,
  getLicensesDetailsUrl,
  refundUrlPaginated
} from "./endPoints";

export const queryKeys = {
  //   authenticate: (chargerId) => {
  //     return ["charger", { method: "GET", url: chargerUrl(chargerId) }];
  //   },
  user: () => ["user", { url: userUrl }],
  users: (teamId) => ["users", { url: usersUrl(teamId) }],
  roles: (teamId) => ["roles", { url: rolesUrl(teamId) }],
  role: (teamId, roleId) => ["getRole", { url: getRoleUrlId(teamId, roleId) }],
  usersByTeam: (_, id) => [
    "usersByTeam",
    { url: getTeamUrl(id, teamUsersUrl) },
  ],
  chargersWithoutLicense: (teamId) => [
    "chargersWithoutLicense",
    { url: teamChargersWithoutLicenseUrl(teamId) },
  ],
  allowedChargerCount: (teamId) => [
    "allowedChargerCount",
    { url: teamAllowedChargerCountUrl(teamId) },
  ],
  addChargerLicense: (teamId) => [
    "addChargerLicense",
    { url: chargerLicenseUrl(teamId) },
  ],
  settlementPercentage: [
    "getSettlementPercentage",
    { url: getSettlementPercentageUrl },
  ],
  paymentDetailsForPriceGroup: (teamId) => [
    "getPaymentDetailsForPriceGroup",
    { url: getPaymentDetailsForPriceGroupUrl(teamId) },
  ],
  paymentDetailsOfCompany: (companyId) => [
    "getPaymentDetailsOfCompany",
    { url: getPaymentDetailsOfCompany(companyId) },
  ],
  setupCatgegory: (body) => ["setupCatgegory", { url: categoryUrl, body }],
  setupUserType: (body) => ["setupUserType", { url: userTypeUrl, body }],
  chargers: (teamId, args) => [
    "getChargers",
    { url: getTeamUrl(teamId, `${chargersUrl}${args ? '?c=' + args.c : ''}`) },
  ],
  chargerList: (teamId, params) => [
    "getPaginatedChargers",
    {
      url: getChargerListUrl(teamId, params)
    },
  ],
  charger: (teamId, chargerId) => [
    "getCharger",
    { url: getTeamUrl(teamId, chargerIdUrl(chargerId)) },
  ],
  generateQR: (teamId, chargerId) => [
    "generateQR",
    { url: getTeamUrl(teamId, `/charger/${chargerId}/generateQr`) },
  ],
  transactions: (teamId) => [
    "getTransactions",
    { url: getTeamUrl(teamId, transactionsUrl) },
  ],
  transactionStatus: (teamId, transactionId) => [
    "transactionStatus",
    { url: getTeamUrl(teamId, `/${transactionIdUrl(transactionId)}/status`) },
  ],
  chargerTransactions: (teamId, chargerId) => [
    "getTransactions",
    { url: getTeamUrl(teamId, chargerTransactions(chargerId)) },
  ],
  chargerActiveTransactions: (teamId, chargerId) => [
    "getActiveTransactions",
    { url: getTeamUrl(teamId, chargerActiveTransactions(chargerId)) },
  ],
  tagTransactions: (teamId, tagId) => [
    "getTransactions",
    { url: getTeamUrl(teamId, tagTransactions(tagId)) },
  ],
  transaction: (teamId, transactionId) => [
    "getTransaction",
    { url: getTeamUrl(teamId, transactionIdUrl(transactionId)) },
  ],
  transactionMeterValue: (teamId, transactionId, connectorId) => [
    "getMeterValue",
    {
      url: getTeamUrl(
        teamId,
        meterValueUrl(transactionIdUrl(transactionId), connectorId)
      ),
    },
  ],
  serviceRequest: (teamId) => [
    "getServiceRequests",
    { url: serviceRequestUrl(teamId) },
  ],
  serviceRequestForParent: (id) => [
    "getServiceRequestsForParent",
    { url: serviceRequestForParentUrl(id) },
  ],
  serviceRequestDetails: (teamId, id) => [
    "getServiceRequestDetails",
    { url: getServiceRequestDetailsUrl(teamId, id) },
  ],
  chargingProfileList: (teamId, charging_profile_pk) => [
    "getChargingProfileList",
    { url: newGetTeamUrl(teamId, charging_profile_pk) },
  ],
  chargingProfileDetails: (teamId, chargingProfileId) => [
    "getChargingProfileDetails",
    { url: newGetTeamUrl(teamId, chargingProfileId) },
  ],
  refund: (teamId, tId = 0) => [
    "refund",
    { url: `${refundUrl(teamId)}${tId ? "/" + tId : ""}` },
  ],

  // this is new key for paginated refund list, we can remove above refund key once all the components are migrated to use this new key
  refundPaginated: (teamId, page = 0, pageSize = 10) => [
    "refund",
    {
      url: refundUrlPaginated(teamId, page, pageSize),
      teamId,
      page,
      pageSize
    }
  ],
  tags: (teamId) => ["getTags", { url: getTeamUrl(teamId, tagsUrl) }],
  tagsForRemoteOp: (teamId, chargerPk, mail) => [
    "getTagsForRemoteOp",
    {
      url: getTeamUrl(teamId, tagsForRemoteOpUrl, chargerPk),
      method: "POST",
      body: { email: mail },
    },
  ],
  availableTags: (teamId, customerId) => [
    "availableTags",
    { url: getTeamUrl(teamId, availableTagsUrl, customerId) },
  ],
  tag: (teamId, tagId) => [
    "getTag",
    { url: getTeamUrl(teamId, tagIdUrl(tagId)) },
  ],
  tagsCharger: (teamId, tagId, chargerId = null) => [
    "getTagCharger",
    { url: getTeamUrl(teamId, tagChargerUrl(tagId, chargerId)) },
  ],
  tagsUser: (teamId, tagId) => [
    "getTagUser",
    { url: tagUserUrl(teamId, tagId) },
  ],
  priceGroups: (teamId) => [
    "getPriceGroup",
    { url: getTeamUrl(teamId, priceGroupsUrl) },
  ],
  priceGroup: (teamId, priceGroupId) => [
    "getPriceGroup",
    { url: getTeamUrl(teamId, priceGroupIdUrl(priceGroupId)) },
  ],
  teams: (parentTeamId) => ["getTeams", { url: teamsUrl(parentTeamId) }],

  team: (id) => ["getTeam", { url: teamUrlId(id) }],
  getComapnyProductCatalog: (teamId) => ["getCompanyProductCatalogUrl", { url: getCompanyProductCatalogUrl(teamId) }],
  userDetail: (teamId, id) => ["getUser", { url: getUserDetailUrl(teamId, id) }],
  profile: () => ["getProfile", { url: getUserProfile() }],
  companyList: () => ["companyList", { url: companyUrl }],
  productCatalog: () => ["productCatalog", { url: productCatalogUrl }],
  productCategory: () => ["productCategory", { url: productCategoryUrl }],
  companyproductCatalogUrl: () => ["companyProductCatalog", { url: companyProductCatalogUrl }],
  companyProductCatalog: (teamId, id) => [
    "getCompanyProductCatalog",
    { url: getCompanyProductCatalogUrlId(id) },
  ],
  getProductDetails: (teamId, productId) => ["getProductDetails", { url: getProductCatalogUrlId(productId) }],
  getProductCategory: (teamId, categoryId) => ["getProductCategory", { url: getProductCategoryUrlId(categoryId) }],
  company: (teamId, id) => ["getCompany", { url: getCompanyUrlId(id) }],
  features: () => ["getFeatures", { url: featureUrl }],
  viewLogs: (teamId, chargerId) => [
    "viewLogs",
    { url: getTeamUrl(teamId, viewLogsUrl(chargerId)) },
  ],
  getConnectorsUrl: (teamId, chargerId) => [
    "getConnectorsUrl",
    { url: getTeamUrl(teamId, getConnectorsUrl(chargerId)) },
  ],
  getTagsByChargerId: (teamId, chargerId) => [
    "getTagsByChargerId",
    { url: getTeamUrl(teamId, getTagsByChargerIdUrl(chargerId)) },
  ],
  customers: (t, [s]) => [
    "customerList",
    { url: customerListByTeamIdUrl(t) + "?cmType=" + s.cmType },
  ],
  mobileCustomers: (t, page = 0, pageSize = 10, search = "") => [
    "mobileCustomerList",
    { url: mobileCustomersListByTeamIdUrl(t, page, pageSize, search) },
  ],
  sendPromoCodeMobileCustomers: (t) => [
    "sendPromoCodeMobileCustomers",
    { url: sendPromoCodeMobileCustomerUrl(t) },
  ],
  customer: (t, id) => ["customer", { url: getCustomerById(t, id) }],
  customerTags: (teamId, customerId) => [
    "customerTags",
    { url: customerTagsById(teamId, customerId) },
  ],
  cmCustomers: () => ["cmCustomerList", { url: cmCustomerUrl }],
  cmsUsers: () => ["cmsUsersList", { url: cmsUsersUrl }],
  cmUserDetails: (teamId, id) => ["cmUserDetails", { url: cmUserDetailsUrl(teamId, id) }],
  cmWalletHistory: (teamId, id) => [
    "cmWalletHistory",
    { url: cmUserWalletHistoryUrl(teamId, id) },
  ],
  cmCustomerTransactionHistory: (teamId, userId) => [
    "cmCustomerTransactionHistory",
    { url: cmUserTransactionHistoryUrl(teamId, userId) },
  ],
  getPromoCodes: (teamId, id) => [
    "getPromoCodes",
    { url: getPromoCodesUrl(teamId, id) },
  ],
  payoutBulkCal: (teamId) => [
    "getBulkCalPayouts",
    { url: getTeamUrl(teamId, bulkCalPayoutsUrl) },
  ],
  transactionList: (
    teamId,
    page,
    pageSize,
    filterteam,
    filterGPTeam,
    companyType
  ) => [
      "getTransactions",
      {
        url: getTransactionUrl(
          teamId,
          transactionsUrl,
          page,
          pageSize,
          filterteam,
          filterGPTeam,
          companyType
        ),
      },
    ],
  getCurrencies: () => ["getCurrencies", { url: getCurrenciesUrl() }],
  getSmsGateway: () => ["getSmsGateway", { url: getSmsGatewayUrl() }],
  generatePaymentLink: (teamId, chargerId) => [
    "generatePaymentLink",
    {
      url: getTeamV3Url(teamId, `/charger/${chargerId}/generate_payment_link`),
    },
  ],
  cmUserPassword: () => ["cmUserPassword", { url: resetPasswordByAdminUrl }],
  chargerInstructionBoard: (teamId, chargerId) => [
    "getChargerInstructionBoard",
    { url: getChargerInstructionBoardUrl(teamId, chargerId) },
  ],
  payoutInvoices: (id, body) => [
    "getPayoutInvoices",
    { url: teamPayoutInvoices(id), body },
  ],
  payoutInvoicesPdf: (id, payoutId) => [
    "getPayoutInvoicesPdf",
    { url: getPayoutInvoicesPdfUrl(id, payoutId) },
  ],
  getDropdownValues: (type, params) => ["dropdown", { url: `${getDropDownValues(type)}${params ? '?args=' + JSON.stringify([params]) : ''}` }],
  getReportGst: (teamId, body) => ["getReportGst", { url: reportGst(teamId), body }],
  getERPDropDownValues: () => ["getERPDropDownValues", { url: getERPDropDownValues }],
  availablePaymentGatewayListByCompany: (companyId) => [
    "availablePaymentGatewayListByCompany",
    { url: availablePaymentGatewayListByCompanyUrl(companyId) },
  ],
  thirdPartySMS: (companyId) => ["thirdPartySMS", { url: thirdPartySmsConfig(companyId) }],
  smsTemplates: (companyId, templateId) => ["smsTemplates", { url: smsTemplatesUrl(companyId, templateId) }],

  partners: () => ["partners", { url: partnersUrl }],
  partner: (id) => ["partner", { url: partnerUrl(id) }],
  savePartner: () => ["savePartner", { url: onboardUrl }],
  handshake: (partnerId) => ["handshake", { url: handshake(partnerId) }],
  handshakeAsync: (partnerId, body) => ["handshakeAsync", { url: handshakeAsyncUrl(partnerId), body, method: "POST" }],
  handshakeRetry: (partnerId, body) => ["handshakeRetry", { url: handshakeRetryUrl(partnerId), body, method: "POST" }],
  handshakeCancel: (partnerId, body) => ["handshakeCancel", { url: handshakeCancelUrl(partnerId), body, method: "POST" }],
  handshakeStatusAsync: (partnerId) => ["handshakeStatusAsync", { url: handshakeStatusAsyncUrl(partnerId) }],
  handshakeStatus: (partnerId) => ["handshakeStatus", { url: `${partnersUrl}/${partnerId}/handshake/status` }],
  getByPartyId: (id) => ["getByPartyId", { url: `${partnersUrl}/${id}/detail` }],

  // OCPI Tokens
  ocpiTokens: (params) => ["ocpiTokens", { url: ocpiTokensUrl(params), params }],
  ocpiToken: (countryCode, partyId, uid, type) => [
    "ocpiToken",
    { url: ocpiTokenUrl(countryCode, partyId, uid, type), countryCode, partyId, uid, type }
  ],
  partnerGetAllTokens: (_, params) => ["partnerGetAllTokens", { url: partnerGetAllTokensUrl(params) }],

  // Partner Commands
  sendCommand: () => ["sendCommand", { url: partnerSendCommandUrl }],
  partnerCommands: (partnerId, params) => [
    "partnerCommands",
    { url: partnerCommandsUrl(partnerId, params), partnerId, params }
  ],
  partnerCommandStatus: (commandId) => [
    "partnerCommandStatus",
    { url: partnerCommandStatusUrl(commandId), commandId }
  ],

  // Additional Partner Keys
  partnerByPartyId: (partyId) => ["partnerByPartyId", { url: partnerByPartyIdUrl(partyId), partyId }],

  // Command Builder Dropdown Keys
  commandBuilderData: () => ["commandBuilderData", { url: commandBuilderDataUrl }],
  activeCommands: (params = {}) => ["activeCommands", { url: activeCommandsUrl(params) }],
  commandsHistory: (_, params = {}) => ["commandsHistory", { url: commandsHistoryUrl(params) }],

  // Sessions API
  ongoingSessions: (_, params = {}) => ["ongoingSessions", { url: ongoingSessionsUrl(params) }],
  completedSessions: (_, params = {}) => ["completedSessions", { url: completedSessionsUrl(params) }],

  // Tariffs API
  getAllTariffs: (_, params = {}) => ["getAllTariffs", { url: partnerGetAllTariffsUrl(params) }],

  // EMSP Markup API
  emspMarkupUpsert: (_, body = {}) => ["emspMarkupUpsert", { url: emspMarkupUpsertUrl, body, method: "POST" }],

  // Analytics API
  analytics: (_, body = {}) => ["analytics", { url: analyticsUrl, body, method: "POST" }],
  analyticsTypes: () => ["analyticsTypes", { url: analyticsTypesUrl }],
  analyticsMetadata: () => ["analyticsMetadata", { url: analyticsMetadataUrl }],
  analyticsMetrics: (_, { category, params }) => ["analyticsMetrics", { url: analyticsMetricsUrl(category, params) }],
  analyticsReport: (_, body = {}) => ["analyticsReport", { url: analyticsReportUrl, body, method: "POST" }],

  // Locations API
  getAllLocations: (_, params = {}) => ["getAllLocations", { url: getAllLocationsUrl(params) }],


  // Payout Schedule
  payoutSchedule: (_, companyId) => ["payoutSchedule", { url: getPayoutScheduleUrl(companyId) }],
  effectivePayoutSchedule: (_, companyId, parentCompanyId) => ["effectivePayoutSchedule", { url: getEffectivePayoutScheduleUrl(companyId, parentCompanyId) }],

  // Payout Run History
  payoutRunHistory: (_, companyId, params) => ["payoutRunHistory", { url: getPayoutRunHistoryUrl(companyId, params) }],
  payoutRunSummary: (_, companyId, days, companyType) => ["payoutRunSummary", { url: getPayoutRunSummaryUrl(companyId, days, companyType) }],
  payoutRunDetail: (_, logId) => ["payoutRunDetail", { url: getPayoutRunDetailUrl(logId) }],

  // OCPI Dashboard API
  dashboardData: () => ["dashboardData", { url: dashboardDataUrl }],

  // Promo Codes
  promoCodes: (teamId) => ["promoCodes", { url: promoCodesUrl(teamId) }],
  promoCode: (teamId, promoCodeId) => ["promoCode", { url: promoCodeByIdUrl(teamId, promoCodeId) }],
  checkPromoCode: (teamId, code) => ["checkPromoCode", { url: `${checkPromoCodeUrl(teamId)}?code=${code}` }],
  updatePromoCodeStatus: (teamId, promoCodeId) => ["updatePromoCodeStatus", { url: updatePromoCodeStatusUrl(teamId, promoCodeId) }],

  promoStats: (teamId, params) => [
    "promoStats",
    {
      url: `${promoCodesUrl(teamId)}/statsData${params ? `?${Object.entries(params).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join("&")}` : ''}`
    }
  ],
  promoGraph: (teamId, params) => [
    "promoGraph",
    {
      url: `${promoCodesUrl(teamId)}/graph${params ? `?${Object.entries(params).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join("&")}` : ''}`
    }
  ],
  licensesDetails: (teamId, params = {}) => {
    const { count = false } = params;
    return [
      "licensesDetails", 
      { 
        url: getLicensesDetailsUrl(teamId, count), 
        teamId, 
        count 
      }
    ];
  },
};
